<script lang="ts">
  import { readable } from "svelte/store";
  import { form as svelteForm, field } from "svelte-forms2";
  import { required } from "svelte-forms2/validators";
  import { validateEmailApi } from "@shared/svelte/Validators/Email";

  // components
  import EmailInput from "@shared/svelte/Components/EmailInput.svelte";
  import FormInputError from "@shared/svelte/Components/FormInputError.svelte";

  // services
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import { blur, change } from "@shared/services/svelte_form_input_service";
  import { EventTracking } from "@shared/services/event_tracking/events";
  import { TargetObjectEntity } from "@shared/services/event_tracking/entities";
  import * as RetailerUserSignupService from "@onboarding2/services/retailer_user_signup";

  // stores
  import { OnboardingSessionStore } from "@onboarding2/svelte/Stores/OnboardingSessionStore";
  import SignupUserStore from "@onboarding2/svelte/Stores/SignupUserStore";

  const { trackClick } = EventTracking;

  const email = field("email", "", [required(), validateEmailApi()], {
    validateOnChange: false,
    stopAtFirstError: true,
  });
  const emailForm = svelteForm(email);
  const params = readable(window["stateParams"]);
  const signupUserStore = SignupUserStore({});

  let submitting = false;

  const handleClick = (type: string): void => trackClick(type);

  const runSubmitUserWrapper = async (): Promise<void> => {
    await emailForm.validate();

    if (!$emailForm.valid) return;

    submitting = true;
    HttpPromise({
      method: "GET",
      url: "/api/onboarding/check_email",
      data: { email: $email.value },
    })
      .then(res => {
        if (res.message == "Email has already been taken") {
          RetailerUserSignupService.setErrors(signupUserStore, [res.message]);
        } else {
          window["stateService"].go("layout.signup", { email: res.email, ...$params });
        }
      })
      .catch(res => RetailerUserSignupService.setErrors(signupUserStore, [res.error]))
      .finally(() => (submitting = false));
  };

  if ($params?.error == "emailInUse") {
    RetailerUserSignupService.setErrors(signupUserStore, ["Email has already been taken"]);
  } else if ($params?.error == "invalidEmail") {
    RetailerUserSignupService.setErrors(signupUserStore, ["Please use a different email address"]);
  }

</script>

<div data-grid-area="main" style="background: #F5F7F7">
  <form
    class="fizz-card fizz-flow-16 fizz-radius-medium fizz-elevation-1"
    on:submit|preventDefault={runSubmitUserWrapper}
  >
    <h2 class="fizz-heading-2 fizz-text-center fizz-stack-32">Sign up for Provi</h2>
    <div>
      <EmailInput
        name="email"
        label="Email"
        labelClasses="stack-4"
        field={email}
        on:blur={blur}
        on:change={change}
      >
        <FormInputError form={emailForm} errorName="email.required">
          Email is required
        </FormInputError>
        <FormInputError form={emailForm} errorName="email.not_an_email">
          Email format is invalid
        </FormInputError>
      </EmailInput>
    </div>
    <button
      class="fizz-button-secondary fizz-full-width fizz-button-large"
      disabled={submitting}
      type="submit"
      on:click={() => handleClick("onboarding_continue_button")}
    >
      Continue
    </button>
  </form>
</div>
